export default __webpack_public_path__ + "static/media/logo.1dcb719d.png";